module.exports = __webpack_public_path__ + "static/media/thumbnail-case.1f72b011.png";